import { Box, useTheme } from "@mui/material";
import React from "react";
import spinner from "../../../assets/spinner.gif";

const Loading = () => {
  const theme = useTheme();
  return (
    <Box
      className="loading-wrapper"
      display="flex"
      alignItems="center"
      justifyContent="center"
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      zIndex={10}
      sx={{
        bgcolor: "bgs.transparent",
        pointerEvents: "none"
      }}
    >
      <Box
        component="img"
        className="loading"
        src={spinner}
        alt="Mediacross loading spinner"
        maxWidth="40px"
      />
    </Box>
  );
};

export default Loading;
